module.exports = __webpack_public_path__ + "static/gallery-6-a66b77372d81b5ec4adfd0941af82c50.jpg";